<div class="flex flex-col gap-4" [dir]="isArabic() ? 'rtl' : 'ltr'">
  <div class="mb-4 flex items-center justify-between">
    <h1 class="textTabsColor text-3xl font-bold" i18n="@@addNewPharmacyTitle">Add New Pharmacy</h1>
  </div>

  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="textTabsColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round">
    <circle cx="12" cy="12" r="10"></circle>
    <line x1="12" y1="2" x2="12" y2="6"></line>
    <line x1="12" y1="18" x2="12" y2="22"></line>
    <line x1="4.93" y1="4.93" x2="7.76" y2="7.76"></line>
    <line x1="16.24" y1="16.24" x2="19.07" y2="19.07"></line>
    <line x1="2" y1="12" x2="6" y2="12"></line>
    <line x1="18" y1="12" x2="22" y2="12"></line>
  </svg>

  <form (submit)="onSubmit()" [formGroup]="pharmacyForm" class="overflow-hidden rounded-xl bg-white shadow-2xl">
    <div class="flex border-b border-gray-200 bg-gray-50 text-center">
      <div
        (click)="goToStep(1)"
        class="flex flex-1 items-center justify-center gap-2 border-b-2 py-4 transition-all hover:cursor-pointer"
        [ngClass]="currentStep() === 1 ? 'borderTabsColor bg-white' : 'border-transparent'">
        @if (currentStep() > 1) {
          <div class="bgPrimaryColor flex h-6 w-6 items-center justify-center rounded-full">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-4 w-4 text-white"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
            </svg>
          </div>
        } @else {
          <div
            class="flex h-6 w-6 items-center justify-center rounded-full border"
            [ngClass]="currentStep() === 1 ? 'borderTabsColor textTabsColor' : 'border-gray-400 text-gray-400'">
            <span class="text-xs">01</span>
          </div>
        }

        <span
          class="text-lg font-semibold"
          [ngClass]="currentStep() === 1 ? 'textTabsColor' : currentStep() > 1 ? 'text-gray-700' : 'text-gray-400'"
          i18n="@@wizardStep1">
          Pharmacy Information
        </span>
      </div>

      <div
        (click)="goToStep(2)"
        class="flex flex-1 items-center justify-center gap-2 border-r border-b-2 border-l border-gray-200 py-4 transition-all hover:cursor-pointer"
        [ngClass]="currentStep() === 2 ? 'borderTabsColor bg-white' : 'border-b-transparent'">
        @if (currentStep() > 2) {
          <div class="bgPrimaryColor flex h-6 w-6 items-center justify-center rounded-full">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-4 w-4 text-white"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
            </svg>
          </div>
        } @else {
          <div
            class="flex h-6 w-6 items-center justify-center rounded-full border"
            [ngClass]="currentStep() === 2 ? 'borderTabsColor textTabsColor' : 'border-gray-400 text-gray-400'">
            <span class="text-xs">02</span>
          </div>
        }

        <span
          class="text-lg font-semibold"
          [ngClass]="currentStep() === 2 ? 'textTabsColor' : currentStep() > 2 ? 'text-gray-700' : 'text-gray-400'"
          i18n="@@wizardStep2">
          Pharmacy Address
        </span>
      </div>

      <div
        (click)="goToStep(3)"
        class="flex flex-1 items-center justify-center gap-2 border-b-2 py-4 transition-all hover:cursor-pointer"
        [ngClass]="currentStep() === 3 ? 'borderTabsColor bg-white' : 'border-transparent'">
        <div
          class="flex h-6 w-6 items-center justify-center rounded-full border"
          [ngClass]="currentStep() === 3 ? 'borderTabsColor textTabsColor' : 'border-gray-400 text-gray-400'">
          <span class="text-xs">03</span>
        </div>

        <span
          class="text-lg font-semibold"
          [ngClass]="currentStep() === 3 ? 'textTabsColor' : 'text-gray-400'"
          i18n="@@wizardStep3">
          Pharmacy Settings
        </span>
      </div>
    </div>

    <div class="p-8">
      @if (currentStep() === 1) {
        <div class="space-y-6">
          <div class="grid grid-cols-1 gap-6 md:grid-cols-2">
            <app-pharamcy-nickname [pharmacyForm]="pharmacyForm" />
            <app-pharamcist-name
              [pharmacyForm]="pharmacyForm"
              [showFullNameDropdown]="showFullNameDropdown()"
              [fullNameResults]="fullNameResults()"
              (selectFullName)="selectFullName($event)"
              [loadingPharmacist]="loadingPharmacist()"
              [errorPharmacist]="errorPharmacist()" />
            <app-tax-identification-number [pharmacyForm]="pharmacyForm" />
            <app-pharmacist-national-id [pharmacyForm]="pharmacyForm" />
            <app-commercial-registeration-number [pharmacyForm]="pharmacyForm" />
          </div>

          <div class="mt-4 grid grid-cols-1 gap-6 md:grid-cols-2">
            <app-commercial-regestration-image
              [formSubmitted]="formSubmitted()"
              [pharmacyForm]="pharmacyForm"
              (uploadSuccess)="onFileUploaded($event, 'commercialRegistrationFid')" />
            <app-tax-image
              [formSubmitted]="formSubmitted()"
              [pharmacyForm]="pharmacyForm"
              (uploadSuccess)="onFileUploaded($event, 'taxRegistrationCertificateFid')" />
            <app-pharmacy-contract-image
              [formSubmitted]="formSubmitted()"
              [pharmacyForm]="pharmacyForm"
              (uploadSuccess)="onFileUploaded($event, 'pharmacyContractFid')" />
            <app-national-id-card
              [formSubmitted]="formSubmitted()"
              [pharmacyForm]="pharmacyForm"
              (uploadSuccess)="onFileUploaded($event, 'pharmacistNationalIdFid')" />
            <app-pharmacy-license-image
              [formSubmitted]="formSubmitted()"
              [pharmacyForm]="pharmacyForm"
              (uploadSuccess)="onFileUploaded($event, 'pharmacyLicenseFid')" />
          </div>
        </div>
      }

      @if (currentStep() === 2) {
        <div class="space-y-6">
          <app-pharmacy-address [pharmacyForm]="pharmacyForm" />

          <div class="mt-4 grid grid-cols-1 gap-6 md:grid-cols-3">
            <app-governate
              [pharmacyForm]="pharmacyForm"
              [governorates]="governorates()"
              (onGetCities)="onGetCities($event)" />
            <app-city
              [pharmacyForm]="pharmacyForm"
              [cities]="governorateCities()"
              (onGetRegions)="onGetRegions($event)" />
            <app-region [pharmacyForm]="pharmacyForm" [regions]="citiesRegions()" />
          </div>

          <app-pharmacy-location [pharmacyForm]="pharmacyForm"></app-pharmacy-location>
        </div>
      }

      @if (currentStep() === 3) {
        <div class="space-y-6">
          <div class="grid grid-cols-1 gap-6 md:grid-cols-2">
            <app-pharmacy-segment [pharmacyForm]="pharmacyForm" />
            <app-pharmacy-quota [pharmacyForm]="pharmacyForm" />
            <app-assign-representative
              [pharmacyForm]="pharmacyForm"
              [showRepresentativeDropdown]="showRepresentativeDropdown()"
              [representativeResults]="representativeResults()"
              (selectRepresentative)="selectRepresentative($event)"
              [loadingRepresentative]="loadingRepresentative()"
              [errorRepresentative]="errorRepresentative()" />
          </div>

          @if (errorCreatePharamcy()) {
            <div class="mt-4">
              <app-error [apiError]="errorCreatePharamcy()" />
            </div>
          }
        </div>
      }
    </div>

    <div class="flex items-center justify-end gap-4 bg-gray-50 px-8 py-4">
      <button
        type="button"
        (click)="onCancel()"
        class="rounded-[8px] border border-gray-300 bg-white px-8 py-2 text-[14px] font-[500] text-gray-700 hover:cursor-pointer hover:bg-gray-50">
        <span i18n="@@adminCategoryFormCancelButton">Cancel</span>
      </button>

      @if (currentStep() < 3) {
        <button
          type="button"
          (click)="nextStep()"
          class="bgTabsColor flex min-w-[120px] cursor-pointer items-center justify-center rounded-[8px] px-10 py-2.5 text-[15px] font-bold text-white shadow-sm transition-colors disabled:cursor-not-allowed disabled:opacity-50">
          {{ isArabic() ? "التالي" : "Next" }}
        </button>
      } @else {
        <button
          type="submit"
          [disabled]="loadingCreatePharmacy()"
          class="bgTabsColor rounded-[8px] px-8 py-2 text-[14px] font-[500] text-white transition-all"
          [class.cursor-not-allowed]="loadingCreatePharmacy()"
          [class.opacity-50]="loadingCreatePharmacy()">
          @if (loadingCreatePharmacy()) {
            <span i18n="@@loading">loading...</span>
          } @else {
            <span i18n="@@save">Save</span>
          }
        </button>
      }
    </div>
  </form>
</div>
